import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { useMemo } from "react";
import { ContentBlockerField, EContentBlockerVisualContentType, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { IRRELEVANT_VISUAL_TYPES } from "./visual-type.js";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
const VISUAL_CONTENT_HERO_TYPES = [
    EContentBlockerVisualContentType.Map,
    EContentBlockerVisualContentType.FeedText,
    EContentBlockerVisualContentType.FeedVideo,
    EContentBlockerVisualContentType.Generic
];
Object.freeze(VISUAL_CONTENT_HERO_TYPES);
function FormFieldContentBlockerTemplateVisualContentType() {
    const { t } = useTranslation();
    const options = useMemo(()=>[
            {
                label: t("Map"),
                value: EContentBlockerVisualContentType.Map
            },
            {
                label: t("Audio player"),
                value: EContentBlockerVisualContentType.AudioPlayer
            },
            {
                label: t("Video player"),
                value: EContentBlockerVisualContentType.VideoPlayer
            },
            {
                label: t("Feed (text)"),
                value: EContentBlockerVisualContentType.FeedText
            },
            {
                label: t("Feed (image/video)"),
                value: EContentBlockerVisualContentType.FeedVideo
            },
            {
                label: t("None of these (generic)"),
                value: EContentBlockerVisualContentType.Generic
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.VisualContentType,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prev, next)=>prev.visualType !== next.visualType || prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>(!IRRELEVANT_VISUAL_TYPES.includes(getFieldValue("visualType")) || !IRRELEVANT_VISUAL_TYPES.includes(getFieldValue(TemplateMetaDataField.Extends)?.["visualType"])) && /*#__PURE__*/ _jsx(Form.Item, {
                    label: getFieldNameTranslated(ContentBlockerField.VisualContentType, t),
                    shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
                    required: true,
                    children: ({ getFieldValue })=>{
                        const extended = getFieldValue(TemplateMetaDataField.Extends);
                        const extendedVisualContentType = extended?.[ContentBlockerField.VisualContentType];
                        return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                            extendsFieldName: ContentBlockerField.VisualContentType,
                            disableStrategies: getDisableStrategies(),
                            onKeepContent: extended && /*#__PURE__*/ _jsx(Form.Item, {
                                noStyle: true,
                                children: /*#__PURE__*/ _jsx(Radio.Group, {
                                    value: extendedVisualContentType,
                                    options: options,
                                    optionType: "button",
                                    buttonStyle: "solid",
                                    disabled: true
                                })
                            }),
                            children: /*#__PURE__*/ _jsx(Form.Item, {
                                name: ContentBlockerField.VisualContentType,
                                noStyle: true,
                                rules: [
                                    {
                                        required: true,
                                        message: t("Please choose visual content type.")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Radio.Group, {
                                    options: options,
                                    optionType: "button",
                                    buttonStyle: "solid"
                                })
                            })
                        });
                    }
                })
        })
    });
}
export { FormFieldContentBlockerTemplateVisualContentType, VISUAL_CONTENT_HERO_TYPES };
